import React from 'react'

export default function Loading() {
    return (
        <div className="flex h-screen">
        <p className="m-auto">
          <i className="fa fa-circle-notch fa-spin text-5xl text-blue-600"></i>
        </p>
      </div>
    )
}
